import { useMediaQuery } from "@/hooks/useMediaQuery";
import { Button, type ButtonProps } from "@iluvatar/ui-kit";
import { lazy, Suspense, useState } from "react";

import { MEDIAQUERY } from "@iluvatar/global/src/constants";
import "./feedback-button.css";

const FeedbackDialog = lazy(() =>
  import("./FeedbackDialog").then((module) => ({
    default: module.FeedbackDialog,
  })),
);

export function FeedbackButton({
  reporterId,
  neon = false,
  size = "md",
}: {
  reporterId: string;
  neon?: boolean;
  size?: ButtonProps["size"];
}) {
  const [open, setOpen] = useState(false);
  const isMobile = useMediaQuery(MEDIAQUERY.tablet);
  return (
    <>
      <Button
        variant="outline"
        size={size}
        onClick={() => setOpen(true)}
        className={`m-2 shrink-0 self-center${neon ? " feedback-button-neon !text-uik-text" : ""}`}
      >
        {isMobile ? "Feedback" : "Add feedback"}
      </Button>
      {open && (
        <Suspense fallback={<div role="status">Loading feedback…</div>}>
          <FeedbackDialog
            reporterId={reporterId}
            onClose={() => setOpen(false)}
          />
        </Suspense>
      )}
    </>
  );
}
